export default __webpack_public_path__ + "static/media/icon_fb.a020dd94.svg";